import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { membershipList } from "../../api/membership";

const initialState = {
  list: [],
  studentName: '',
  discipline: localStorage.getItem("discipline")
    ? localStorage.getItem("discipline")
    : "",
  student_type: localStorage.getItem("student_type")
    ? localStorage.getItem("student_type")
    : "",

  student_data: localStorage.getItem("selectedStudent")
    ? JSON.parse(localStorage.getItem("selectedStudent"))
    : "",
  allow_free_membership: 0,
  is_trial_class_available: 0,
  trial_sessions: [],
};

export const MembershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    listing: (state, action) => {
      state.list = action.payload;
    },
    studentName: (state, action) => {
      state.studentName = action.payload;
    },
    changeDiscipline: (state, action) => {
      state.discipline = action.payload;
    },
    changeStudentType: (state, action) => {
      state.student_type = action.payload;
    },
    changeStudentData: (state, action) => {
      state.student_data = action.payload;
    },
    allowFreeMembership: (state, action) => {
      state.allow_free_membership = action.payload;
    },
    isTrialClassAvailable: (state, action) => {
      state.is_trial_class_available = action.payload;
    },
    trialSessions: (state, action) => {
      state.trial_sessions = action.payload;
    },
  },
});

export const FetchMembershipListing = createAsyncThunk(
  "membershipListing",
  async (obj, { dispatch }) => {
    try {
      const response = await membershipList(obj);
      if (response?.code === 1) {
        localStorage.setItem("studentName", response?.data?.studentName);
        localStorage.setItem("studentType", response?.data?.studentType);
        dispatch(listing(response?.data?.membership_list));
        dispatch(allowFreeMembership(response?.data?.allow_free_membership));
        dispatch(isTrialClassAvailable(response?.data?.is_trial_class_available));
        // dispatch(trialSessions(response?.data?.trial_sessions || [])); // Disabled trial sessions
      }
      return response;
    } catch (error) {
      toast.error(error?.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const {
  listing,
  changeDiscipline,
  changeStudentType,
  changeStudentData,
  studentName,
  allowFreeMembership,
  isTrialClassAvailable,
  trialSessions
} = MembershipSlice.actions;

export default MembershipSlice.reducer;
